// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"43dbcf94e8f1669b","5808":"bf3b217b7955ee0e"}[chunkId] + ".css";
};